import { ParseHref } from './types';

export const parseHref = (href: string = ''): ParseHref => {
  if (!href) {
    return { type: 'unknown', value: '' };
  }
  if (href?.startsWith('modal://')) {
    return { type: 'modal', value: href.replace('modal://', '') };
  }
  return { type: 'link', value: href };
};
